<template>
  <el-container>
    <!-- 头部 -->
    <el-header>
      <div class="header-left">
        <div class="header-logo">
          <img
            v-if="platformData.platformAdminLogo"
            :src="platformData.platformAdminLogo.imagePath"
            alt=""
          />
        </div>
        <div class="header-title">{{ platformData.platformAdminName }}</div>
        <div class="header-region">
          <el-dropdown @command="switchRegion">
            <span class="el-dropdown-link">
              {{ regionList[currentRegion].text
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in regionList"
                :key="index"
                :command="index"
                >{{ item.text }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="header-right">
        <!-- 一级导航 -->
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          background-color="rgba(255,255,255,.5)"
          text-color="#000"
          active-text-color="#1F5BCC"
          router
        >
          <template v-for="(item, index) in list">
            <el-menu-item
              v-if="!item.hidden"
              :key="index"
              :index="'/' + item.path"
              >{{ item.meta.title }}</el-menu-item
            >
          </template>
        </el-menu>

        <div class="header-lang">
          <el-dropdown @command="switchLang">
            <div class="header-user">
              <i class="iconfont icon-diqiu"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in langList"
                :key="index"
                :command="item.type"
              >
                <span>{{ item.text }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="header-operation">
          <el-dropdown @command="userOperation">
            <div class="header-user">
              <el-avatar
                v-if="userInfo.imagePath"
                :size="30"
                :src="userInfo.imagePath"
              ></el-avatar>
              <el-avatar
                v-else
                :size="30"
                src="https://img2.baidu.com/it/u=2249825600,2123294280&fm=26&fmt=auto"
              ></el-avatar>
              <span class="el-dropdown-link">{{ userInfo.username }}</span>
            </div>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="2">{{
                $t("omission.text43")
              }}</el-dropdown-item>
              <el-dropdown-item command="1">{{
                $t("pages.index.text1")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <!-- 内容 -->
    <el-main>
      <router-view class="app-view"></router-view>
    </el-main>
    <!-- 修改密码弹窗 -->
    <ChangePassword
     @dialogClose="dialogClose"
     :dialogVisible="dialogVisible"
    />
  </el-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ChangePassword from "./login/changePassword";
export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
      userInfo: {},
      langList: [
        {
          text: "简体中文",
          type: "zh-CN",
        },
        {
          text: "English",
          type: "en-US",
        },
        {
          text: "日本語",
          type: "ja-Jp",
        },
      ],
    };
  },
  mounted() {
    //语言切换
    this.setMenuLang();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (localStorage.getItem("lang")) {
      if (localStorage.getItem("lang") == "zh-CN") {
        this.$i18n.locale = "zh-CN";
      }
      if (localStorage.getItem("lang") == "ja-Jp") {
        this.$i18n.locale = "ja-Jp";
      }
      if (localStorage.getItem("lang") == "en-US") {
        this.$i18n.locale = "en-US";
      }
    } else {
      if (this.platformData.region.region == "cn") {
        this.$i18n.locale = "zh-CN";
      }
      if (this.platformData.region.region == "jp") {
        this.$i18n.locale = "ja-Jp";
      }
      if (this.platformData.region.region == "eur") {
        this.$i18n.locale = "en-US";
      }
      if (this.platformData.region.region == "usa") {
        this.$i18n.locale = "en-US";
      }
      if (this.platformData.region.region == "sea") {
        this.$i18n.locale = "en-US";
      }
    }
  },
  components: {
   ChangePassword
  },
  computed: {
    ...mapState([
      "defaultActive",
      "newRouterList",
      "platformData",
      "regionList",
      "currentRegion",
    ]),
  },
  methods: {
    ...mapMutations(["switchRegionIndex"]),
    ...mapActions(["switchRegionActions"]),
    //切换区域
    switchRegion(e) {
      // switchRegion
      this.switchRegionActions(e);
      // this.switchRegionIndex(e)
    },
    //语言切换
    switchLang(e) {
      localStorage.setItem("lang", e);
      this.$i18n.locale = e;
      this.setMenuLang();
    },
    // 设置导航路由国际化
    setMenuLang() {
      let arr = this.newRouterList[0].children;
      // let arr = routerList[0].children
      this.list = this.setMenuArr(arr);
    },
    //循环设置
    setMenuArr(arr) {
      for (let i in arr) {
        arr[i].meta.title = this.$t(`menu.${arr[i].name}`);
        if (arr[i].children) {
          for (let j in arr[i].children) {
            arr[i].children[j].meta.title = this.$t(
              `menu.${arr[i].children[j].name}`
            );
            if (arr[i].children[j].children) {
              for (let k in arr[i].children[j].children) {
                arr[i].children[j].children[k].meta.title = this.$t(
                  `menu.${arr[i].children[j].children[k].name}`
                );
              }
            }
          }
        }
      }
      return arr;
    },
     // 关闭修改密码弹窗
    dialogClose() {
      this.dialogVisible = false;
    },

    //用户操作
    userOperation(e) {
      let that = this;
      if (e == 1) {
        this.$confirm(that.$t("pages.index.text2"), that.$t("public.text6"), {
          confirmButtonText: that.$t("button.determine"),
          cancelButtonText: that.$t("button.cancel"),
          type: "warning",
        })
          .then(() => {
            this.request.logout().then(() => {
              this.$message({
                type: "success",
                message: that.$t("pages.index.text3"),
              });
              localStorage.clear();
              sessionStorage.clear();
              this.$router.push({ path: "/login" });
            });
          })
          .catch(() => {});
      }
      if (e == 2) {
       this.dialogVisible = true;
      }
    },
  },
};
</script>


<style scoped>
.el-container {
  overflow: auto;
}
.el-header {
  color: #000;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  margin-bottom: 1px;
  z-index: 1;
  height: 80px;
  box-shadow: 0px 3px 6px rgba(210, 222, 244, 0.69);
}
.header-left {
  display: flex;
  align-items: center;
}
.header-right {
  display: flex;
  align-items: center;
}
.header-title {
  font-size: 20px;
  margin: 0 20px;
}
.header-lang {
  margin: 0 30px;
}
.header-user i {
  font-size: 20px;
}
.header-user {
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  margin-left: 10px;
  color: rgba(31, 91, 204, 1);
}

.view {
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  /* box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2), -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 10px; */
}
.layout-row {
  flex: 1;
  overflow: hidden;
}
.layout-col {
  height: 100%;
  overflow: hidden;
}
.layout-right {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.header-region {
  background: rgba(210, 222, 244, 0.35);
  border-radius: 15px;
  padding: 4px 8px;
  box-sizing: border-box;
}
.header-logo {
  width: 120px;
}
.header-logo img {
  width: 100%;
}
</style>